const initialState = {
    hospital: [], 
    country:[],
    speciality:[],
    language:[],
    application:[],
    
  
  };
  
  const NewCaseReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA1_SUCCESS':
            return {... state, hospital:action.payload};
            case 'FETCH_DATA2_SUCCESS':
            return {... state, country:action.payload};
            case 'FETCH_DATA3_SUCCESS':
            return {... state, speciality:action.payload};
            case 'FETCH_DATA4_SUCCESS':
            return {... state, language:action.payload};
            case 'FETCH_DATA6_SUCCESS':
            return {... state, application:action.payload};
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default NewCaseReducers;
  
  